import { render, staticRenderFns } from "./ProductTableTemplate.vue?vue&type=template&id=f67386e8&scoped=true&"
import script from "./ProductTableTemplate.vue?vue&type=script&lang=js&"
export * from "./ProductTableTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67386e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f67386e8')) {
      api.createRecord('f67386e8', component.options)
    } else {
      api.reload('f67386e8', component.options)
    }
    module.hot.accept("./ProductTableTemplate.vue?vue&type=template&id=f67386e8&scoped=true&", function () {
      api.rerender('f67386e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/ProductTableTemplate.vue"
export default component.exports